import { Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBookingWizard } from './BookingWizardContext';

// Step finale — Richiesta di prenotazione inviata (solo flusso standard, non auto-accept).
// Raggiungibile solo con booking.sent (impostato da StepSummary dopo l'invio riuscito).
const StepSuccess = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { booking } = useBookingWizard();

    if (!booking.sent) {
        return <Navigate to="../opzione" replace />;
    }

    return (
        <div className="w-full flex flex-col items-center gap-6 text-center py-8">
            <div className="w-20 h-20 rounded-full border-4 border-[#225424] flex items-center justify-center">
                <i className="fi fi-br-check text-3xl text-[#225424] pt-1"></i>
            </div>
            <h2>{t('BookingWizard.success.title')}</h2>
            <p className="text-neutral-500">{t('BookingWizard.success.body')}</p>
            <p className="text-neutral-500 text-sm">{t('SendRequest.monitorInProfile')}</p>
            <button className="bg-[#225424] py-3 px-6 text-white rounded-xl w-full md:w-fit mt-4" onClick={() => navigate('/')}>
                {t('BookingWizard.success.backHome')}
            </button>
        </div>
    );
};

export default StepSuccess;
